const pathsAllowedToSpecificContract = [
    '/',
    '/dados_empresa',
    '/informacoes',
    '/gerenciar_usuarios',
    '/alterar_senha',
    '/faturamento',
    '/consultar_faturas',
    '/registro_acidentados',
    '/guias',
    '/selecionar_beneficiario_guia',
    '/consultar_guias',
    '/selecionar_solicitacao_guias',
    '/preencher_dados_solicitacao_guias',
    '/carregar_documentos_solicitacao_guias',
    '/validar_solicitacao_guias',
    '/beneficiario_eventual',
    '/selecionar_beneficiario_eventual',
    '/beneficiario_eventual_dados',
    '/incluir_beneficiario_eventual',
    '/incluir_beneficiario_eventual_dados_titular',
    '/incluir_beneficiario_eventual_dados_empresa',
    '/incluir_beneficiario_eventual_dados_beneficiario',
    '/incluir_beneficiario_eventual_validar_dados',
    '/selecionar_alterar_beneficiario_eventual',
    '/alterar_beneficiario_eventual_dados',
    '/alterar_beneficiario_eventual_validar',
    '/acidente',
    '/selecionar_beneficiario_registro_acidente',
    '/preencher_registro_acidente',
    '/aguardar_registro_acidente',
    '/selecionar_beneficiario_consulta_acidente',
    '/visualizar_beneficiario_consulta_acidente',
    '/selecionar_beneficiario_edita_acidente',
    '/edita_acidente',
    '/aguardar_edita_acidente',
    '/selecionar_excluir_beneficiario_eventual',
    '/excluir_beneficiario_eventual_dados',
    '/excluir_beneficiario_eventual_validar',
    '/carta_atendimento',
    '/carta_atendimento_consulta',
    '/carta_atendimento_dados',
    '/consulta_beneficiario_eventual',
    '/agendamento_consulta',
    '/agendamento_consulta_dados',
    '/agendamento_consulta_dados_consulta',
    '/agendamento_consulta_medico',
    '/agendamento_consulta_confirmar_dados',
    '/cancelamento_consulta',
    '/lista_consulta_dados',
    '/historico_consultas',
    '/historico_consultas_dados',
    '/historico_consultas',
    '/historico_consultas_dados',
];

export { pathsAllowedToSpecificContract };
